// Utility to clear all profile-related cache and storage
export const clearProfileCache = () => {
  // Clear sessionStorage items related to profile
  sessionStorage.removeItem("profileCompleted");
  
  // Clear localStorage items that might interfere
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.includes('profile') || key.includes('supabase'))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
  
  console.log("Profile cache and storage cleared");
};